module.exports = require('./helpers/bundle-url').getBundleURL('44zrN') + "white_logo_transparent_background.2184994d.png";